import { ApplicationTable } from "@/admin/components/applicationTable";
import { ApplicationOverview } from "@/components/ApplicationOverview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/admin/pvp/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <div className="p-6">
        <ApplicationOverview />
      </div>
      <h2 className="w-full px-6 text-2xl font-semibold">Applications</h2>
      <ApplicationTable />
    </>
  );
}
